import React, { createContext, useContext, useState, useEffect, useCallback } from 'react';

const ThemeContext = createContext({});

function hexToRgb(hex) {
  const result = /^#?([a-f\d]{2})([a-f\d]{2})([a-f\d]{2})$/i.exec(hex);
  return result ? `${parseInt(result[1], 16)}, ${parseInt(result[2], 16)}, ${parseInt(result[3], 16)}` : '0, 0, 0';
}

export const ThemeProvider = ({ children }) => {
  const [theme, setTheme] = useState(null);

  const applyTheme = useCallback((t) => {
    if (!t) return;
    const root = document.documentElement;
    Object.entries(t).forEach(([key, value]) => {
      if (value && typeof value === 'string' && value.startsWith('#')) {
        root.style.setProperty(`--theme-${key}`, value);
        root.style.setProperty(`--theme-${key}-rgb`, hexToRgb(value));
      }
    });
    setTheme(t);
  }, []);

  const loadTheme = useCallback(async (token) => {
    if (!token) return;
    try {
      const API_URL = process.env.REACT_APP_BACKEND_URL;
      const res = await fetch(`${API_URL}/api/company-settings/theme/public`, {
        headers: { 'Authorization': `Bearer ${token}` }
      });
      if (res.ok) {
        const data = await res.json();
        applyTheme(data);
      }
    } catch (err) {
      // Theme loading failed silently, defaults from CSS apply
    }
  }, [applyTheme]);

  return (
    <ThemeContext.Provider value={{ theme, applyTheme, loadTheme }}>
      {children}
    </ThemeContext.Provider>
  );
};

export const useTheme = () => useContext(ThemeContext);
export default ThemeContext;
